import React from "react";
import img1 from "../assets/buildingimg3.avif";
import img2 from "../assets/bulidingigm2.jpeg";
import img3 from "../assets/buildingimg3.avif";
import AnimatedCarousel from "../component/animatedcarousel/animatedcarousel";
import EzyMpspackage from "../component/ezymps/ezympspackage";
import Market from "../component/marketing/market";

const EzyMpspage = () => {
  const slides = [
    {
      img: img1,
      title: "EZYMPS",
      subtitle: "Empowering You with Rights, Responsibilities & Commitment",
    },
    {
      img: img2,
      title: "EZYMPS",
      subtitle: "Empowering You with Rights, Responsibilities & Commitment",
    },
    {
      img: img3,
      title: "EZYMPS",
      subtitle: "Empowering You with Rights, Responsibilities & Commitment",
    },
  ];

  return (
    <>
      <AnimatedCarousel slides={slides} />
      <EzyMpspackage />
      <Market />
    </>
  );
};

export default EzyMpspage;
